import { Skeleton } from "@chakra-ui/skeleton";
import { SkeletonProps } from "@chakra-ui/react";
import { colors } from "goi_common";

type Props = Omit<SkeletonProps, "startColor" | "endColor">;

function Gray100Skeleton(props: Props) {
  return <Skeleton startColor={colors.gray100} endColor={colors.gray200} {...props} />;
}

export default Gray100Skeleton;
